import { Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';

import { PreferenceEditorSectionHeading } from '../components/PreferenceEditorSectionHeading';
import { UserPreferenceKey } from '../types';
import { PreferenceBrowserStorage } from '../utils/preference-session-storage';
import type {
  PreferenceEditorProps,
  PreferenceMeta,
} from './preferenceEditors';

export const meta: PreferenceMeta = {
  id: UserPreferenceKey.ContingentWorkers,
  label: 'Contingent Workers',
};

export default function ContingentWorkersEditor({
  affectedScope,
  onPreferenceUpdate,
  preferences,
  diff,
}: PreferenceEditorProps) {
  const [includeContingent, setIncludeContingent] = useState('include');

  useEffect(() => {
    setIncludeContingent(
      preferences[UserPreferenceKey.ContingentWorkers] ? 'include' : 'exclude'
    );
  }, [preferences]);

  const onUpdate = useCallback(
    (value: string) => {
      onPreferenceUpdate?.(
        UserPreferenceKey.ContingentWorkers,
        value === 'include'
      );
      setIncludeContingent(value);
      PreferenceBrowserStorage.update(
        affectedScope,
        UserPreferenceKey.ContingentWorkers,
        value === 'include'
      );
    },
    [affectedScope, onPreferenceUpdate]
  );

  return (
    <>
      <PreferenceEditorSectionHeading
        title="Workforce Segment"
        indicateDiff={diff?.includes(meta.id) ?? false}
      />
      <RadioGroup
        value={includeContingent}
        onChange={onUpdate}
        colorScheme="green"
        size="sm"
        mt={3}
      >
        <Stack gap={3}>
          <Stack gap={1}>
            <Radio value="include">Full Workforce</Radio>
            <Text ml={5} fontSize="xs" color="gray.500" lineHeight="1.4">
              Full Workforce includes all workers: employees, contractors,
              consultants, and other contingent workers who may not appear in
              official company reports.
            </Text>
          </Stack>
          <Stack gap={1}>
            <Radio value="exclude">Exclude Contingent</Radio>
            <Text ml={5} fontSize="xs" color="gray.500" lineHeight="1.4">
              Exclude Contingent shows only traditional employees, excluding
              contractors, freelancers, and temporary staff.
            </Text>
          </Stack>
        </Stack>
      </RadioGroup>
    </>
  );
}
